import { AideEntree, AideSommaire } from './aide.models';

/** Chemin seul, sans requête ni ancre ni barre finale. */
export function cheminSeul(url: string): string {
  const chemin = url.split(/[?#]/)[0].replace(/\/+$/, '');
  return chemin === '' ? '/' : chemin;
}

function segments(chemin: string): string[] {
  return chemin.split('/').filter((s) => s !== '');
}

/** `/moni/factures/:id/:action` correspond à `/moni/factures/12/voir` (même nombre de segments). */
export function correspond(motif: string, url: string): boolean {
  const attendus = segments(cheminSeul(motif));
  const reels = segments(cheminSeul(url));
  return attendus.length === reels.length
    && attendus.every((s, i) => s.startsWith(':') || s === reels[i]);
}

/** Plus un motif a de segments fixes, plus il est précis : `/moni/factures/nouveau` passe avant `/moni/factures/:id`. */
function specificite(motif: string): number {
  return segments(cheminSeul(motif)).filter((s) => !s.startsWith(':')).length;
}

/**
 * Le tuto de l'écran affiché : celui dont un `ecran` correspond à l'URL, le
 * plus précis d'abord ; à égalité, le premier du sommaire.
 */
export function articlePourUrl(url: string, sommaire: AideSommaire | null): AideEntree | null {
  let meilleur: AideEntree | null = null;
  let score = -1;
  for (const rubrique of sommaire?.rubriques ?? []) {
    for (const article of rubrique.articles) {
      for (const motif of article.ecran ?? []) {
        if (correspond(motif, url) && specificite(motif) > score) {
          meilleur = article;
          score = specificite(motif);
        }
      }
    }
  }
  return meilleur;
}

/** Rubrique d'aide de chaque zone du BO (préfixe d'URL le plus long). */
const RUBRIQUE_PAR_ZONE: readonly [string, string][] = [
  ['/moni/dashboard', 'demarrer'],
  ['/moni/settings', 'demarrer'],
  ['/moni/utilisateurs', 'demarrer'],
  ['/moni/roles', 'demarrer'],
  ['/moni/boutiques', 'demarrer'],
  ['/moni/profile', 'demarrer'],
  ['/moni/clients', 'clients'],
  ['/moni/companies', 'clients'],
  ['/moni/produits', 'clients'],
  ['/moni/categories', 'clients'],
  ['/moni/taxes', 'clients'],
  ['/moni/devises', 'clients'],
  ['/moni/devis', 'factures'],
  ['/moni/factures', 'factures'],
  ['/moni/factures-recurrentes', 'factures'],
  ['/moni/ventes', 'commandes'],
  ['/pos', 'caisse'],
  ['/logistiki', 'comptabilite'],
  ['/logistiki/encaissements', 'paiements'],
  ['/logistiki/situation-factures', 'paiements'],
  ['/logistiki/compta', 'compta-generale'],
  ['/pyxidi', 'paiements'],
  ['/cms', 'site'],
  ['/kratisi', 'reservations'],
  ['/agelii', 'emailing'],
  ['/entoli', 'automatisations'],
  // Interface SOLO (plan solo).
  ['/solo/accueil', 'demarrer'],
  ['/solo/parametres', 'demarrer'],
  ['/solo/clients', 'clients'],
  ['/solo/factures', 'factures'],
  ['/solo/devis', 'factures'],
  ['/solo/impots', 'impots'],
  ['/skedi', 'projets'],
  ['/pinaki', 'tableaux'],
  ['/kleidi', 'mots-de-passe'],
  ['/arogi', 'support'],
  ['/odigi', 'auto-ecole'],
];

export function rubriquePourUrl(url: string): string | null {
  const chemin = cheminSeul(url);
  let trouve: string | null = null;
  let longueur = -1;
  for (const [zone, rubrique] of RUBRIQUE_PAR_ZONE) {
    if ((chemin === zone || chemin.startsWith(zone + '/')) && zone.length > longueur) {
      trouve = rubrique;
      longueur = zone.length;
    }
  }
  return trouve;
}
